
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control } from "react-hook-form";
import { LocationFormValues } from "./types";

type RegionFieldProps = {
  control: Control<LocationFormValues>;
};

const RegionField = ({ control }: RegionFieldProps) => {
  if (!control) {
    console.error("Form control is missing in RegionField");
    return null;
  }
  
  return (
    <FormField
      control={control}
      name="region"
      render={({ field }) => (
        <FormItem>
          <FormLabel>State/Province/Region</FormLabel>
          <FormControl>
            <Input placeholder="Your state or region" {...field} value={field.value || ""} />
          </FormControl>
          <FormDescription>
            Some regions have specific consumer protection laws.
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default RegionField;
